import Vue from 'vue'
import router from '../../../router'

export const invalidUsageProducts = {
    state: {
        status: 'idle',
        invalidUsageProducts: null,
        pagination: {
            page: 1,
            totalPages: 0,
            perPage: 10,
            totalRecords: null
        },
        sortOptions: [
            {
                query: 'usage.receipt_date',
                label: 'Data'
            },
            {
                query: 'usage.amount',
                label: 'Liczba użyć (nieuznanych)'
            },
            {
                query: 'promo.name',
                label: 'Nazwa promocji'
            }
        ],
        sort: {
            by: 'usage.receipt_date',
            direction: 'desc'
        },
        filters: {
            receiptDates: {
                type: 'dates',
                value: null,
                text: 'Zakres dat użycia promocji',
                additionalText: 'Zakres dat'
            },
            merchantStates: {
                type: 'ui-virtual-list',
                multi: true,
                searcher: false,
                value: [],
                label: 'Stan sklepu',
                getter: 'getCurrentMerchantStatesForSelect'
            },
            shopIds: {
                type: 'ui-virtual-list',
                value: [],
                multi: true,
                searcher: false,
                label: 'Wybierz sklep',
                moduleName: 'merchants',
                fetchAction: 'merchantsFetch',
                getter: 'getMerchantsForSelect',
                disabledLinkGenerator: true
            },
            promotionIds: {
                type: 'ui-virtual-list',
                value: [],
                multi: true,
                moduleName: 'promotions',
                getter: 'getPromotionsForFilters',
                label: 'Promocja'
            }
        }
    },
    mutations: {
        SET_INVALIDUSAGEPRODUCTS_STATUS(state, payload) {
            state.status = payload
        },
        SET_INVALIDUSAGEPRODUCTS(state, payload) {
            state.invalidUsageProducts = payload
        },
        SET_INVALIDUSAGEPRODUCTS_FILTER(state, payload) {
            Vue.set(state.filters[payload.filter], 'value', payload.value)
        },
        RESET_INVALIDUSAGEPRODUCTS_FILTERS(state, payload) {
            Vue.set(state, 'filters', payload)
        },
        SET_INVALIDUSAGEPRODUCTS_SORT(state, payload) {
            state.sort = payload
        },
        SET_INVALIDUSAGEPRODUCTS_TOTALPAGES(state, payload) {
            state.pagination.totalPages = payload
        },
        SET_INVALIDUSAGEPRODUCTS_TOTALRECORDS(state, payload) {
            state.pagination.totalRecords = payload
        },
        SET_INVALIDUSAGEPRODUCTS_CURRENT(state, payload) {
            state.pagination.page = payload
        },
        SET_INVALIDUSAGEPRODUCTS_PERPAGE(state, payload) {
            state.pagination.perPage = payload
        }
    },
    actions: {
        invalidUsageProductsFetch({ state, commit, getters }) {
            commit('SET_INVALIDUSAGEPRODUCTS_STATUS', 'loading')

            if (router.currentRoute.query.page) {
                commit(
                    'SET_INVALIDUSAGEPRODUCTS_CURRENT',
                    +router.currentRoute.query.page
                )
            }
            if (router.currentRoute.query.show) {
                commit(
                    'SET_INVALIDUSAGEPRODUCTS_PERPAGE',
                    +router.currentRoute.query.show
                )
            }

            const params = getters.getInvalidUsageProductsQueryParams

            this.$api
                .get('reports/invalid_usage_products', { params })
                .then(res => {
                    commit(
                        'SET_INVALIDUSAGEPRODUCTS_TOTALRECORDS',
                        +res.data.pagination[0].totalRecords
                    )
                    commit(
                        'SET_INVALIDUSAGEPRODUCTS_TOTALPAGES',
                        +res.data.pagination[0].totalPages
                    )
                    commit('SET_INVALIDUSAGEPRODUCTS', res.data.data)
                })
                .catch(err => {
                    console.log(err)
                })
                .finally(() => [
                    commit('SET_INVALIDUSAGEPRODUCTS_STATUS', 'idle')
                ])
        },
        invalidUsageProductsReportDownload({ getters }) {
            const params = getters.getInvalidUsageProductsQueryParams
            return this.$api
                .post('reports/invalid_usage_products_xlsx', params, {
                    responseType: 'arraybuffer'
                })
                .then(response => {
                    const today = Vue.moment().format('DD-MM-YYYY')

                    const fileLink = document.createElement('a')
                    const blob = new Blob([response.data], {
                        type: '"application/octet-stream"'
                    })
                    fileLink.href = window.URL.createObjectURL(blob)
                    fileLink.download = `Odrzucone-uzycia-mplatform-${today}.xlsx`
                    fileLink.click()
                })
        },
        setInvalidUsageProductsSort({ commit }, payload) {
            commit('SET_INVALIDUSAGEPRODUCTS_SORT', payload)
        }
    },
    getters: {
        getInvalidUsageProducts: state => {
            return state.invalidUsageProducts
        },
        getInvalidUsageProductsStatus: state => {
            return state.status
        },
        getInvalidUsageProductsPagination: state => {
            return state.pagination
        },
        getInvalidUsageProductsFilters: state => {
            return state.filters
        },
        getInvalidUsageProductsSort: state => {
            return state.sort
        },
        getInvalidUsageProductsSortOptions: state => {
            return state.sortOptions
        },
        getInvalidUsageProductsQueryParams: state => {
            const paging = {
                direction: state.sort.direction,
                sort: state.sort.by,
                page: state.pagination.page,
                per: state.pagination.perPage
            }
            return {
                ...paging,
                includes: 'usage,usage.promo,usage.merchant',
                'usage|receipt_date': state.filters.receiptDates.value,
                'merchant|state': state.filters.merchantStates.value.length
                    ? state.filters.merchantStates.value.join(',')
                    : null,
                'usage|merchant_id': state.filters.shopIds.value.length
                    ? state.filters.shopIds.value.join(',')
                    : null,
                'usage|promo_id': state.filters.promotionIds.value.length
                    ? state.filters.promotionIds.value.join(',')
                    : null
            }
        }
    }
}
